import { Injectable } from '@angular/core';
import {SalesWorkflowService} from "./sales-workflow.service";
import {SalesWorkflow} from "../../../enums";
import {MacroFlowService} from 'projects/store/src/app/services/api/v1/macro-flow.service';

@Injectable({
  providedIn: 'root'
})
export class PixelService {
  private readonly  fbq: Function;

  constructor(private salesWorkFlowService: SalesWorkflowService,
              private macroFlowService: MacroFlowService) {
    if (!(window as any).fbq) {
      (window as any).fbq = function (...args: any[]) {
        console.log('[SIMULATED fbq]', ...args);
      };
    }
    this.fbq = (window as any).fbq;
  }

  setLoanData(loan_value: number, biweekly_payment: number, total_term: number){
    sessionStorage.setItem('loan_value', loan_value.toString());
    sessionStorage.setItem('biweekly_payment', biweekly_payment.toString());
    sessionStorage.setItem('total_term', total_term.toString());

  }

  private getLoanData(): { loan_value: number; biweekly_payment: number; total_term: number }{

    return {
      loan_value: parseFloat(sessionStorage.getItem('loan_value') || '0'),
      biweekly_payment: parseInt( sessionStorage.getItem('biweekly_payment') || '0', 10 ),
      total_term: parseInt(sessionStorage.getItem('total_term') || '0', 10),
    }

  }

  trackEvent(eventName: string) {
    const flow = this.salesWorkFlowService.workflow?.code || "kredicash-cliente" ;
    if (flow === this.macroFlowService.getKredicashClienteFlow()){
      const data = this.getLoanData();

      const standardEvents = [
        'PageView',
        'ViewContent',
        'Search',
        'AddToCart',
        'AddToWishlist',
        'InitiateCheckout',
        'AddPaymentInfo',
        'Purchase',
        'Lead',
        'CompleteRegistration',
        'Subscribe'
      ];

      const isStandardEvent = standardEvents.includes(eventName);

      const eventMethod = isStandardEvent ? 'track' : 'track';

      if (typeof this.fbq === 'function') {
        this.fbq(eventMethod, eventName, {
          loan_value: data.loan_value,
          biweekly_payment: data.biweekly_payment,
          total_term: data.total_term
        });
      } else {
        console.warn('fbq is not defined when sending:', eventName);
      }
    }
  }


}
